module.exports = __webpack_public_path__ + "media/images/lp_graduation-2-f839f2ec8eface1f660d1108e5755985.webp";